import { EnglishArabicDTO } from "bnsights-control-library"
import { EmailTemplateInfoDTO } from "./EmailTemplateInfoDTO";
import { SMSTemplateInfoDTO } from "./SMSTemplateInfoDTO";
export class TemplateDTO
{
      ID:number
      IDEncrypted :string
      CategoryItemID?:number
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      CategoryItemName :EnglishArabicDTO=new EnglishArabicDTO();
      Description :EnglishArabicDTO=new EnglishArabicDTO();
      SysName :string
      IsEmail :boolean
      IsSms :boolean
      EnableIntensiveLogging:boolean
      OrganizationID:number
      OrganizationName :EnglishArabicDTO=new EnglishArabicDTO();
      EmailHeaderAndFooterTemplateID?:number
      EmailHeaderAndFooterTemplateName:string
      LanguageModeItemID:number
      LanguageModeItemName:string
      SMS:SMSTemplateInfoDTO
      Email:EmailTemplateInfoDTO
}
     